
import { Link } from 'react-router-dom';
import React, { useState, useEffect } from "react";

const Aboutpromicon = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const partners = [
    { name: "Amazon SPN", logo: "https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg" },
    { name: "Flipkart SPN", logo: "https://static-assets-web.flixcart.com/batman-returns/batman-returns/p/images/fkheaderlogo_exploreplus-def50f.svg" },
    { name: "Microsoft AI", logo: "https://upload.wikimedia.org/wikipedia/commons/9/96/Microsoft_logo_%282012%29.svg" },
    { name: "SAP Partner", logo: "https://upload.wikimedia.org/wikipedia/commons/5/59/SAP_2011_logo.svg" }
  ];

  return (
    <div style={{ backgroundColor: "#020617", color: "#f8fafc", fontFamily: "'Inter', sans-serif", margin: 0 }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;700;900&display=swap');
        html { scroll-behavior: smooth; }
        .nav-link { color: #94a3b8; text-decoration: none; font-size: 13px; font-weight: 700; letter-spacing: 1px; transition: 0.3s; cursor: pointer; }
        .nav-link:hover { color: #3b82f6; }
        .glass-panel { background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.08); padding: 50px; border-radius: 12px; transition: 0.3s; }
        .glass-panel:hover { border-color: #3b82f6; transform: translateY(-5px); background: rgba(59, 130, 246, 0.04); }
        .accent { color: #3b82f6; }
        .btn-main { background: #3b82f6; color: white; border: none; font-size: 18px; padding: 22px 60px; font-weight: 900; letter-spacing: 2px; cursor: pointer; clip-path: polygon(10% 0, 100% 0, 90% 100%, 0% 100%); transition: 0.3s; }
        .btn-main:hover { transform: scale(1.05); box-shadow: 0 0 20px rgba(59, 130, 246, 0.4); }
        .section-label { font-size: 12px; font-weight: 900; letter-spacing: 4px; color: #3b82f6; text-transform: uppercase; margin-bottom: 20px; display: block; }
      `}</style>

{/* 1. DYNAMIC NAVBAR - UPSCALED LOGO */}
      <nav style={{
    position: "fixed", 
    top: 0, 
    width: "100%", 
    zIndex: 1000, 
    display: "flex", 
    justifyContent: "space-between", 
    alignItems: "center",
    padding: scrolled ? "12px 80px" : "25px 80px", 
    transition: "0.4s ease-in-out",
    background: scrolled ? "#ffffff" : "transparent",
    borderBottom: scrolled ? "1px solid #e2e8f0" : "none",
    boxSizing: "border-box"
}}>
  <style>{`
    .nav-item {
      position: relative;
      padding: 15px 0;
    }

    /* MEGA MENU CONTAINER */
    .mega-menu {
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%) translateY(20px);
      background: ${scrolled ? "#ffffff" : "#0f172a"};
      width: 900px; /* Wide format like Yash */
      display: grid;
      grid-template-columns: repeat(4, 1fr); /* 4 Columns of Titles */
      gap: 30px;
      padding: 20px;
      border-radius: 8px;
      box-shadow: 0 30px 60px rgba(0,0,0,0.2);
      opacity: 0;
      visibility: hidden;
      transition: 0.4s cubic-bezier(0.23, 1, 0.32, 1);
      border: 1px solid ${scrolled ? "#e2e8f0" : "rgba(255,255,255,0.1)"};
    }

    .nav-item:hover .mega-menu {
      opacity: 1;
      visibility: visible;
      transform: translateX(-50%) translateY(5px);
    }

    /* TITLE STYLING */
    .menu-title {
      font-size: 13px;
      font-weight: 800;
      color: ${scrolled ? "#0f172a" : "#f3f9f0"};
      text-transform: uppercase;
      letter-spacing: 1px;
      margin-bottom: 15px;
      border-bottom: 1px solid ${scrolled ? "#f1f5f9" : "rgba(255,255,255,0.1)"};
      padding-bottom: 8px;
    }

    /* SUB-SERVICE LINKS */
    .menu-link {
      display: block;
      padding: 6px 0;
      color: ${scrolled ? "#64748b" : "#cbd5e1"};
      text-decoration: none;
      font-size: 13px;
      font-weight: 500;
      transition: 0.2s;
    }
    .menu-link:hover {
      color: #3b82f6 !important;
      padding-left: 5px;
    }
    
    /* MEGA MENU CONTAINER */
    .mega-menu2 {
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%) translateY(20px);
      background: ${scrolled ? "#ffffff" : "#0f172a"};
      width: auto; /* Wide format like Yash */
      display: grid;
      grid-template-columns: repeat(4, 1fr); /* 4 Columns of Titles */
      gap: 30px;
      padding: 10px;
      border-radius: 8px;
      box-shadow: 0 30px 60px rgba(0,0,0,0.2);
      opacity: 0;
      visibility: hidden;
      transition: 0.4s cubic-bezier(0.23, 1, 0.32, 1);
      border: 1px solid ${scrolled ? "#e2e8f0" : "rgba(255,255,255,0.1)"};
    }

    .nav-item:hover .mega-menu2 {
      opacity: 1;
      visibility: visible;
      transform: translateX(-50%) translateY(5px);
    }

    /* TITLE STYLING */
    .menu-title {
      font-size: 13px;
      font-weight: 800;
      color: ${scrolled ? "#0f172a" : "#f3f9f0"};
      text-transform: uppercase;
      letter-spacing: 1px;
      margin-bottom: 15px;
      border-bottom: 1px solid ${scrolled ? "#f1f5f9" : "rgba(255,255,255,0.1)"};
      padding-bottom: 8px;
    }

    /* SUB-SERVICE LINKS */
    .menu-link {
      display: block;
      padding: 6px 0;
      color: ${scrolled ? "#64748b" : "#cbd5e1"};
      text-decoration: none;
      font-size: 13px;
      font-weight: 500;
      transition: 0.2s;
    }
    .menu-link:hover {
      color: #3b82f6 !important;
      padding-left: 5px;
    }
  `}</style>

  

  {/* LOGO AREA - Same as your script */}
  <div style={{ display: "flex", alignItems: "center", cursor: "pointer" }} onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>
    <img src="/logo.png" alt="Promicon" style={{ height: scrolled ? "38px" : "52px", transition: "0.4s", filter: scrolled ? "none" : "brightness(0) invert(1)" }} />
    <div style={{ fontSize: scrolled ? "22px" : "28px", fontWeight: "900", color: scrolled ? "#0f172a" : "#ffffff", letterSpacing: "-1.5px" }}>PROMICON</div>
  </div>

  {/* LINKS AREA */}
  <div style={{ display: "flex", gap: "45px", alignItems: "center" }}>
    
    {/* SERVICES MEGA MENU 1*/}
    <div className="nav-item">
      <a href="#Services" style={{ color: scrolled ? "#475569" : "#ffffff", textDecoration: "none", fontSize: "14px", fontWeight: "700" }}>SERVICES</a>
      
      <div className="mega-menu">
        {/* Column 1 */}
        <div>
          <div className="menu-title">Ecommerce Management</div>
          <Link to="/EnterpriseSolutions/Amazonaccountmanagement" className="menu-link">Amazon Account Management</Link>
          <Link to="/EnterpriseSolutions/Flipkartaccountmanagement" className="menu-link">Flipkart Account Management</Link>
          <Link to="/EnterpriseSolutions/Meeshoaccountmanagement" className="menu-link">Meesho Account Management</Link>
          <Link to="/EnterpriseSolutions/Brand-Registry" className="menu-link">Brand Registry & Account Setup</Link>
        </div>

        {/* Column 2 */}
        <div>
          <div className="menu-title">Listing and Cataloging</div>
          <Link to="/ListingandCataloging/Amazon-Listing" className="menu-link">Amazon Product Listing</Link>
          <Link to="/ListingandCataloging/Flipkart-Listing" className="menu-link">Flipkart Product Listing</Link>
          <Link to="/ListingandCataloging/Meesho-Listing" className="menu-link">Meesho Product Listing</Link>
          <Link to="/ListingandCataloging/Meesho-Listing" className="menu-link">Shopsy Product Listing</Link>
          <Link to="/ListingandCataloging/Catalog-Optimization" className="menu-link">Catalog Optimization</Link>
          <Link to="/ListingandCataloging/ListingSEO-ContentEnhancement " className="menu-link">Listing SEO & Content Enhancement</Link>
        </div>

        {/* Column 3 */}
        <div>
          <div className="menu-title">Ecommerce Advertising</div>
          <Link to="/EcommerceAdvertsing/Amazon-advertising" className="menu-link">Amazon PPC Management</Link>
          <Link to="/EcommerceAdvertsing/Flipkart-advertising" className="menu-link">Flipkart Ads Management</Link>
          <Link to="/EcommerceAdvertsing/Meta-advertising" className="menu-link">Meta ads Optimization</Link>
        </div>

        {/* Column 4 */}
        <div>
          <div className="menu-title">Branding and Content</div>
          <Link to="/BrandingandContent/Aplus-Content" className="menu-link">Amazon A+ Content</Link>
          <Link to="/BrandingandContent/Flipkart-RPD" className="menu-link">Flipkart RPD</Link>
          <Link to="/BrandingandContent/Infographics" className="menu-link">Infographics</Link>
          <Link to="/BrandingandContent/Store-front" className="menu-link">Amazon Store Front</Link>
          <Link to="/BrandingandContent/AmazonBrand-Story" className="menu-link">Amazon Brand Story</Link>
        </div>

        {/* Row 2 - Column 1 */}
        <div style={{marginTop: "20px"}}>
          <div className="menu-title">Enterprise Solutions</div>
          <Link to="/EnterpriseSolutions/Financial-Systems" className="menu-link">Financial Systems Management</Link>
          <Link to="/EnterpriseSolutions/Enterprise-Implementation" className="menu-link">Enterprise System Implementation</Link>
          <Link to="/EnterpriseSolutions/Businessprocess-Optimization" className="menu-link">Business Process Optimization</Link>
          <Link to="/EnterpriseSolutions/Enterprise-Integration" className="menu-link">Enterprise Integration & Automation</Link>
        </div>

        {/* Row 2 - Column 2 */}
        <div style={{marginTop: "20px"}}>
          <div className="menu-title">Productivity & Intelligence</div>
          <Link to="/ProductivityandIntelligence/Productivity-Solutions" className="menu-link">Business Productivity Solutions</Link>
          <Link to="/ProductivityandIntelligence/Applications-CRM" className="menu-link">Business Applications & CRM</Link>
          <Link to="/ProductivityandIntelligence/Reporting-Automation" className="menu-link">Data, Reporting & Automation</Link>
          <Link to="/ProductivityandIntelligence/Cloud-Support" className="menu-link">Cloud & Infrastructure Support</Link>
        </div>
      </div>
    </div>
    {/* SERVICES MEGA MENU 2*/}
    <div className="nav-item">
      <a href="#PARTNERS" style={{ color: scrolled ? "#475569" : "#ffffff", textDecoration: "none", fontSize: "14px", fontWeight: "700" }}>PARTNERS</a>
      
      <div className="mega-menu">
        {/* Column 1 */}
        <div>
          <div className="menu-title">Amazon</div>
          <Link to="/Parterns/Amazon/AmazonRegistration-Launch" className="menu-link">Account Registration and Launch</Link>
          <Link to="/Parterns/Amazon/Amazon-management" className="menu-link">Account Management</Link>
          <Link to="/Parterns/Amazon/Amazonlisting-cataloging" className="menu-link">Listing and Cataloging</Link>
          <Link to="/Parterns/Amazon/Amazon-Campaignmanager" className="menu-link">Advertising</Link>
          <Link to="/Parterns/Amazon/Amazon-Reinstatement" className="menu-link">Account Reinstatement</Link>
          <Link to="/Parterns/Amazon/Aplus-info" className="menu-link">A+ Content & Infographics</Link>
          <Link to="/Parterns/Amazon/Storefront" className="menu-link">Storefront</Link>
        </div>

        {/* Column 2 */}
        <div>
          <div className="menu-title">Flipkart</div>
          <Link to="/Parterns/Flipkart/FlipkartAccount-Creation" className="menu-link">Account creation and launch</Link>
          <Link to="/Parterns/Flipkart/FlipkartAccount-Management" className="menu-link">Account Management</Link>
          <Link to="/Parterns/Flipkart/FlipkartAccount-Advertising" className="menu-link">Advertising</Link>
          <Link to="/Parterns/Flipkart/FlipkartAccount-RPD" className="menu-link">Flipkart RPD</Link>
        </div>

        {/* Column 3 */}
        <div>
          <div className="menu-title">Meesho</div>
          <Link to="/Parterns/Meesho/MSAccountCreationlaunch" className="menu-link">Account Creation and launch</Link>
          <Link to="/Parterns/Meesho/MSAccount-Management" className="menu-link">Account Management</Link>
          <Link to="/Parterns/Meesho/MS-Advertising" className="menu-link">Advertising</Link>
        </div>

        {/* Column 4 */}
        <div>
          <div className="menu-title">SAP</div>
          <Link to="/Parterns/SAP/SAP-FICO" className="menu-link">SAP FICO</Link>
          <Link to="/Parterns/SAP/SAP-BTP" className="menu-link">SAP BTP</Link>
          <Link to="/Parterns/SAP/Rise-with-SAP" className="menu-link">Rise with SAP</Link>
          <Link to="/Parterns/SAP/SAP-S4HANA" className="menu-link">SAP S/4HANA</Link>
          <Link to="/Parterns/SAP/SAP-Support" className="menu-link">SAP Support</Link>
        </div>

        {/* Row 2 - Column 1 */}
        <div style={{marginTop: "20px"}}>
          <div className="menu-title">Microsoft</div>
          <Link to="/Parterns/Microsoft/Microsoft-365" className="menu-link">Microsoft 365</Link>
          <Link to="/Parterns/Microsoft/Dynamic-Solutions" className="menu-link">Dynamics Business Solutions</Link>
          <Link to="/Parterns/Microsoft/Microsoft-Cloud-Platform" className="menu-link">Microsoft Cloud Platform</Link>
          <Link to="/Parterns/Microsoft/Microsoft-SupportServices" className="menu-link">Microsoft Support Services</Link>
        </div>

        {/* Row 2 - Column 2 */}
        <div style={{marginTop: "20px"}}>
          <div className="menu-title">Meta</div>
          <Link to="/Parterns/Meta/Meta-advertising" className="menu-link">Advertising</Link>
          <Link to="/Parterns/Meta/Audience-Targeting-Strategy" className="menu-link">Audience Targeting & Strategy</Link>
          <Link to="/Parterns/Meta/CreativeAd-Optimization" className="menu-link">Creative & Ad Optimization</Link>
          <Link to="/Parterns/Meta/Tracking-Performance-Analytics" className="menu-link">Tracking & Performance Analytics</Link>
        </div>
      </div>
    </div> 

    {/* SERVICES MEGA MENU 3*/}
    <div className="nav-item">
      <a  style={{ color: scrolled ? "#475569" : "#ffffff", textDecoration: "none", fontSize: "14px", fontWeight: "700" }}>ABOUT US</a>
      <div className="mega-menu2">
        {/* Column 1 */}
        <div>
          <div className="menu-title">About Us</div>
          <Link to="/about-us" className="menu-link">About Promicon</Link>
          <Link to="/Blogs" className="menu-link">Blogs</Link>
          
        </div>
      </div>
      
    </div>
    {/* SERVICES MEGA MENU 4*/}
    <div className="nav-item">
      <a  style={{ color: scrolled ? "#475569" : "#ffffff", textDecoration: "none", fontSize: "14px", fontWeight: "700" }}>POLICIES</a>
      
      <div className="mega-menu2">
        {/* Column 1 */}
        <div>
          <div className="menu-title">Policies</div>
          <Link to="/Policies/Privacy-Policy" className="menu-link">Privacy Policy</Link>
          <Link to="/Policies/Terms-Conditions" className="menu-link">Terms and Condition</Link>
          <Link to="/Policies/Refund-Cancellation" className="menu-link">Refund & Cancellation Policy</Link>
        </div>
      </div>
    </div>

    {/* Rest of Nav Items */}
    <Link 
  to="/careers" 
  style={{ 
    color: scrolled ? "#475569" : "#ffffff", 
    textDecoration: "none", 
    fontSize: "14px", 
    fontWeight: "700" 
  }}
>
  CAREERS
</Link>

    <Link to="/contact-us" style={{ textDecoration: 'none' }}>
  <button 
    className="btn-main" 
    style={{ 
      background: "#3b82f6", 
      color: "white", 
      border: "none", 
      padding: "12px 28px", 
      fontSize: "13px", 
      fontWeight: "900", 
      cursor: "pointer", 
      clipPath: "polygon(10% 0, 100% 0, 90% 100%, 0% 100%)",
      display: "block" 
    }}
  >
    Contact Us ↗
  </button>
</Link>
  </div>
</nav>

      {/* --- MAIN CONTENT --- */}
      <div style={{ padding: '80px 20px', maxWidth: '1200px', margin: '0 auto' }}>
        


        <style>{`
  .ultimate-footer {
    background-color: #000;
    color: #fff;
    padding: 60px 0 30px 0;
    font-family: 'Inter', sans-serif;
    position: relative;
    overflow: hidden;
  }

  /* KINETIC BACKGROUND - LOCKED EFFECT */
  .kinetic-canvas {
    position: absolute;
    top: 0;
    right: -5%;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    opacity: 0.18;
    pointer-events: none;
    mask-image: linear-gradient(to right, transparent, black 40%);
  }

  .kinetic-line {
    font-size: 110px;
    font-weight: 900;
    line-height: 0.8;
    white-space: nowrap;
    display: flex;
  }

  .line-right { animation: scrollRight 30s linear infinite; }
  .line-left { animation: scrollLeft 35s linear infinite; }

  @keyframes scrollRight { 0% { transform: translateX(-50%); } 100% { transform: translateX(0%); } }
  @keyframes scrollLeft { 0% { transform: translateX(0%); } 100% { transform: translateX(-50%); } }

  .outline-text { -webkit-text-stroke: 1.5px #fff; color: transparent; padding-right: 40px; }
  .solid-text { padding-right: 40px; }

  /* RESTRUCTURED NAVIGATION */
  .footer-inner {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 60px;
    position: relative;
    z-index: 10;
  }

  .footer-top-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 60px;
  }

  .footer-brand h2 {
    font-size: 42px;
    font-weight: 800;
    letter-spacing: -2px;
    margin: 0;
  }

  .footer-brand span { color: #3b82f6; }

  .footer-nav-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr); /* Balanced columns */
    gap: 80px;
  }

  .nav-col h4 {
    font-size: 13px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 2px;
    color: #3b82f6; /* Brand Blue */
    margin-bottom: 25px;
  }

  .nav-link {
    color: #fff;
    text-decoration: none;
    font-size: 15px;
    font-weight: 400;
    display: block;
    margin-bottom: 12px;
    opacity: 0.7;
    transition: all 0.3s ease;
  }

  .nav-link:hover {
    opacity: 1;
    transform: translateX(5px);
  }

  /* ENHANCED SOCIALS & BOTTOM */
  .footer-bottom {
    max-width: 1400px;
    margin: 40px auto 0;
    padding: 30px 60px 0;
    border-top: 1px solid rgba(255,255,255,0.1);
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .copyright { color: #666; font-size: 13px; }

  .social-wrapper {
    display: flex;
    gap: 20px;
  }

  .social-icon {
    width: 50px;
    height: 50px;
    background: rgba(255,255,255,0.05);
    border-radius: 10px; /* Bento rounding */
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
  }

  .social-icon:hover {
    background: #3b82f6;
    transform: translateY(-3px);
  }

  .social-icon svg {
    width: 32px;
    height: 32px;
    fill: #fff;
  }
`}</style>
      </div>
      <footer className="ultimate-footer">
        <div className="kinetic-canvas">
          <div className="kinetic-line line-right">
            <span className="outline-text">PROMICON</span><span className="solid-text">STRATEGY</span>
          </div>
          <div className="kinetic-line line-left">
            <span className="solid-text">ALLIANCE</span><span className="outline-text">CHANGE</span>
          </div>
        </div>
      
        <div className="footer-inner">
          <div className="footer-top-row">
            <div className="footer-brand">
              <h2>PROMICON<span>.</span></h2>
            </div>
      
            <div className="footer-nav-grid">
              <div className="nav-col">
                <h4>Company</h4>
                <Link to="/about-us" className="nav-link">About Us</Link>
                <Link to="/Careers" className="nav-link">Careers</Link>
                <Link to="/contact-us" className="nav-link">Contact Us</Link>
              </div>
              <div className="nav-col">
                <h4>Quick Links</h4>
                <Link to="/Policies/Privacy-Policy" className="nav-link">Privacy Statement</Link>
                <Link to="/Policies/Terms-Conditions" className="nav-link">Terms & Conditions</Link>
                <Link to="/Blogs" className="nav-link">Blogs</Link>
              </div>
              <div className="nav-col">
                <h4>Support</h4>
                <a href="#" className="nav-link">Sitemap</a>
                <a href="#" className="nav-link">Accessibility</a>
                <a href="#" className="nav-link">Preference Center</a>
              </div>
            </div>
          </div>
        </div>
      
        <div className="footer-bottom">
          <p className="copyright">© 2026 Promicon Technologies Private Limited. All rights reserved.</p>
          
          <div className="social-wrapper">
            <a href="https://www.linkedin.com/company/promicon-technologies-pvt-ltd" className="social-icon" aria-label="LinkedIn">
              <svg viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/></svg>
            </a>
            <a href="https://x.com/promicon33863" className="social-icon" aria-label="Twitter">
              <svg viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
            </a>
            <a href="https://www.instagram.com/promicon.digital/" className="social-icon" aria-label="Instagram">
              <svg viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
            </a>
            <a href="https://wa.me/918109416662" className="social-icon" aria-label="Whatsapp">
              <svg viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L0 24l6.335-1.662c1.72.94 3.659 1.437 5.63 1.438h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/></svg>
            </a>
          </div>
        </div>
      </footer>

      

    </div>
  );
};



export default Aboutpromicon;